import React from 'react'
import About from './About'
import Contactus from './Contactus'
import Otherservices from './Otherservices'
import Quicklinks from './Quicklinks'
import './footer.css'

const Footer = () => {
  return (
    <div className="footer">
      <About/>
      <Quicklinks/>
      <Otherservices/>
      <Contactus/>
      <div className="powered-by">
        <a href="https://zedbytes.com" target="_blank">Copyright © {new Date().getFullYear()} Splendid Freight. Powered by Zedbytes.</a>
        
      </div>
      <div className="powered-bys">
        
      </div>
    </div>
  )
}

export default Footer
